export interface ICommandRequest {
  command: string;
  progress?: boolean;

  [key: string]: any;
}

export interface ICommandResponse {
  command: string;
  result: boolean;
  progress: number;
  error: string;

  [key: string]: any;
}

export class WebSocketServiceConfig {
  url: string;
  protocol: string;

  constructor(url: string, protocol: string) {
    this.url = url;
    this.protocol = protocol;
  }
}

export class WebSocketRequestOptions {
  expectedBlobs: number = 0;
  expectedJsons: number = 1;
}

export enum WebSocketConnectionState {
  Opened,
  Connecting,
  Disconnecting,
  Closed,
}
